import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { InferenceAPI, useTokenAndOrgId } from '@/services/utils'
import { toast } from 'react-hot-toast'
import { CreateSSHKeyArgs } from './inference.gen'

export const useGetSSHKeys = () => {
  const { token, orgId } = useTokenAndOrgId()

  return useQuery({
    queryKey: ['ssh-keys', token, orgId],
    enabled: !!token && !!orgId,
    queryFn: async () => {
      const result = await InferenceAPI.listSSHKeys({
        page_size: 100,
        page_number: 1,
      })
      return result.keys
    },
  })
}

export const useDeleteSSHKey = () => {
  const { token, orgId } = useTokenAndOrgId()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (id: string) => {
      const result = await InferenceAPI.deleteSSHKey({
        key_id: Number(id),
      })

      queryClient.invalidateQueries({ queryKey: ['ssh-keys', token, orgId] })
      toast.success('SSH Key deleted successfully')

      return result.ok
    },
  })
}

export const useCreateSSHKey = () => {
  const { token, orgId } = useTokenAndOrgId()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (op: CreateSSHKeyArgs) => {
      const result = await InferenceAPI.createSSHKey({
        alias: op.alias,
        public_key: op.public_key.trim(),
      })

      queryClient.invalidateQueries({ queryKey: ['ssh-keys', token, orgId] })
      toast.success('SSH Key added successfully')

      return result.ok
    },
  })
}
